import React from 'react';

const MoreFiltersTapDisplay = (props) => {

    return (
        <span>필터 추가</span>
    )
}

export default MoreFiltersTapDisplay;
